import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoBackground from "./VideoBackground";

export default function CarouselHero({ data }) {

  const apiUrl = process.env.REACT_APP_STRAPI_URL;
  const [current, setCurrent] = useState(0);
  const [slides, setSlides] = useState([]);
  const [simpleItem, setSimpleItem] = useState(false);

  useEffect(() => {
    setSlides(data);
    if (data?.length <= 1) {
      setSimpleItem(true);
    }
  }, [data]);

  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === slides?.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [isPaused, slides?.length]);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? slides?.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === slides?.length - 1 ? 0 : prev + 1));
  };

  if (!slides || slides?.length === 0) {
    return null;
  }
  return (
    <div
      className="relative w-full overflow-hidden group"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="flex transition-transform duration-500 ease-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide) => (
          <div key={slide.id} className="min-w-full relative">
            <a
              key={slide.id}
              href={slide.link}
              className="min-w-full relative block"
            >
              <VideoBackground
                key={slide.id}
                video={`${apiUrl}${slide.background?.url}`}
                titulo1={slide.title}
                titulo2={slide.description}
                textbutton={slide.text_button}
                link={slide.link}
                logo={`${apiUrl}${slide.logo?.url}`}
                cartel={
                  slide?.info && (
                    <div className="flex flex-row justify-start items-center text-base font-bold text-sidom-light mb-4">
                      <p>{slide?.info}</p>
                      <div className="rounded-full ">
                        <img
                          src={`${apiUrl}${slide?.info_logo?.url}`}
                          alt={slide?.info}
                          className="ml-2 rounded-full w-9 h-9 object-cover border "
                        />
                      </div>
                    </div>
                  )
                }
              />
            </a>
          </div>
        ))}
      </div>

      {!simpleItem && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 flex items-center justify-center h-12 w-12 md:h-16 md:w-20  hover:bg-white rounded-r-full shadow-md transition-all opacity-0 group-hover:opacity-100 backdrop-blur-sm  bg-sidom-light dark:bg-sidom-blue"
          >
            <ChevronLeft className="w-6 h-6 text-gray-800 dark:text-sidom-light" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 flex items-center justify-center h-12 w-12 md:h-16 md:w-20 bg-white/80 hover:bg-white rounded-l-full shadow-md transition-all opacity-0 group-hover:opacity-100 backdrop-blur-sm  bg-sidom-light dark:bg-sidom-blue"
          >
            <ChevronRight className="w-6 h-6  text-gray-800 dark:text-sidom-light" />
          </button>

          <div className="absolute bottom-[100px] left-1/2 -translate-x-1/2 flex gap-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`h-2 rounded-full transition-all duration-300 shadow-sm ${
                  index === current
                    ? "bg-white w-6"
                    : "bg-white/50 w-2 hover:bg-white/80"
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
